import React from 'react';
import Image from 'next/image';
import LeadButton from '@/components/LeadButton';
import { useTranslation } from 'next-i18next';
import TPLink from '@/components/TPLink';

const Trustpilot = () => {
  const { t } = useTranslation(['home']);

  return (
    <div className="mt-[40px] flex flex-col items-center xl:mt-[60px]">
      <div className=" z-10 text-center lg:text-left">
        <LeadButton
          theme="colorfulBorder"
          size="xl"
          traceName="O_WhyWuKong_FirstModule_CTAClick"
          traceGa4Name="new_entry_How_FirstModuleCTA"
        >
          {t('banner-按钮')}
        </LeadButton>
      </div>
      <TPLink>
        <p className="mt-[20px]  flex items-center justify-center text-xs lg:mt-[28px] lg:justify-start lg:text-sm xl:mt-[32px] xl:text-xl">
          <span className="mr-2">Trustpilot</span>
          <span className="h-[14px] w-[81px] lg:h-4 lg:w-[92px] xl:h-[20px] xl:w-[115px]">
            <Image
              alt="WuKong userReviews"
              width={115}
              height={20}
              src="/images/home/userReviews-tp2.png"
              quality={100}
            />
          </span>
          <span className="ml-2" dangerouslySetInnerHTML={{ __html: t('banner-tp-1') }} />
          {/* <span className="px-1 text-wk-words-3 lg:px-1.5">|</span> */}
          {/* <span className="" dangerouslySetInnerHTML={{ __html: t('banner-tp-2') }} /> */}
        </p>
      </TPLink>
    </div>
  );
};

export default Trustpilot;
